import type { ReactNode } from 'react'

export default function FaqItem({
  answer,
  question,
}: {
  answer: string | ReactNode
  question: string
}) {
  return (
    <div className='max-w-screen-2xl py-8'>
      <div className='flex flex-wrap gap-6 lg:flex-nowrap'>
        <h5 className='mr-7 w-full flex-shrink-0 text-pretty text-2xl font-extrabold leading-normal text-neutral800 antialiased lg:w-1/3'>
          {question}
        </h5>
        <p className='block pt-1 text-base font-semibold leading-[180%] tracking-wide text-neutral800 antialiased'>
          {answer}
        </p>
      </div>
    </div>
  )
}
